import 'swiper/css'
import 'swiper/css/navigation'
import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'

let winzer = []
let regions = []
let activeRegion = 'Alle'
let activeLetter = null
let swiperInstance = null
let mountTarget = null

function getSortName(name) { 
  return name.replace(/^(Bio)?Weingut|Familienweingut|Weinhaus|Wein\s*[&+]\s*Sekt|Wein\s+Cabinet/i, '').trim()
}

function extractFromDOM() {
  regions = Array.from(document.querySelectorAll(`${mountTarget} .filter-bar__btn`))
    .map(btn => btn.dataset.region)

  winzer = Array.from(document.querySelectorAll(`${mountTarget} .swiper-slide`)).map(slide => {
    const links = slide.querySelectorAll('.winzer-card__link')
    const emailLink = [...links].find(a => a.getAttribute('href')?.startsWith('mailto:'))
    const websiteLink = [...links].find(a => !a.getAttribute('href')?.startsWith('mailto:'))
    return {
      bild: slide.querySelector('.winzer-card__image')?.getAttribute('src'),
      name: slide.querySelector('.winzer-card__name')?.textContent.trim(),
      anbaugebiet: slide.querySelector('.winzer-card__region')?.textContent.trim(),
      email: emailLink?.textContent.trim(),
      link: websiteLink?.getAttribute('href'),
    }
  })
}

function getFilteredByRegion() {
  return activeRegion === 'Alle' ? winzer : winzer.filter(w => w.anbaugebiet === activeRegion)
}

function renderSlides() {
  let filtered = getFilteredByRegion()
  if (activeLetter) {
    filtered = filtered.filter(w => getSortName(w.name).toUpperCase().startsWith(activeLetter))
  }
  return filtered.map(w => `
    <div class="swiper-slide">
      <div class="winzer-card">
        <img class="winzer-card__image" src="${w.bild}" alt="${w.name}" loading="eager" decoding="async" />
        <div class="winzer-card__body">
          <h6 class="winzer-card__region">${w.anbaugebiet}</h6>
          <h5 class="winzer-card__name">${w.name}</h5>
          <a class="winzer-card__link" href="mailto:${w.email}">${w.email}</a>
          <a class="winzer-card__link" href="${w.link}" target="_blank" rel="noopener">Website</a>
        </div>
      </div>
    </div>
  `).join('') || '<p class="filter-empty">Keine Einträge gefunden.</p>'
}

function renderAlphaButtons() {
  const available = new Set(
    getFilteredByRegion().map(w => getSortName(w.name)[0].toUpperCase())
  )
  return 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').map(letter => `
    <button
      class="filter-alpha__btn${activeLetter === letter ? ' filter-alpha__btn--active' : ''}${!available.has(letter) ? ' filter-alpha__btn--disabled' : ''}"
      data-letter="${letter}"
      aria-pressed="${activeLetter === letter}"
      ${!available.has(letter) ? 'disabled' : ''}
    >${letter}</button>
  `).join('')
}

function renderRegionButtons() {
  return regions.map(r => `
    <button class="filter-bar__btn${r === activeRegion ? ' filter-bar__btn--active' : ''}" data-region="${r}" aria-pressed="${r === activeRegion}">${r}</button>
  `).join('')
}

function activeFilterLabel() {
  const parts = []
  if (activeRegion !== 'Alle') parts.push(activeRegion)
  if (activeLetter) parts.push(activeLetter)
  return parts.length ? `Filter: ${parts.join(', ')}` : 'Filter'
}

function initSwiper() {
  if (swiperInstance) swiperInstance.destroy(true, true)
  swiperInstance = new Swiper(`${mountTarget} .swiper`, {
    modules: [Navigation],
    slidesPerView: 2,
    spaceBetween: 16,
    breakpoints: {
      768:  { slidesPerView: 3, spaceBetween: 20 },
      1044: { slidesPerView: 4, spaceBetween: 24 },
    },
    navigation: {
      nextEl: `${mountTarget} .swiper-button-next`,
      prevEl: `${mountTarget} .swiper-button-prev`,
      addIcons: false,
    },
  })
}

function updateFilterButtons() {
  const availableRegions = activeLetter
    ? new Set(
        winzer
          .filter(w => getSortName(w.name).toUpperCase().startsWith(activeLetter))
          .map(w => w.anbaugebiet)
      )
    : null

  document.querySelectorAll(`${mountTarget} .filter-bar__btn`).forEach(btn => {
    const region = btn.dataset.region
    const isAll = region === 'Alle'
    const active = region === activeRegion
    const isAvailable = !activeLetter || isAll || availableRegions.has(region)

    btn.classList.toggle('filter-bar__btn--active', active)
    btn.classList.toggle('filter-bar__btn--disabled', !isAvailable)
    btn.setAttribute('aria-pressed', String(active))
    if (!isAll) btn.disabled = !isAvailable
  })

  const available = new Set(
    getFilteredByRegion().map(w => getSortName(w.name)[0].toUpperCase())
  )
  document.querySelectorAll(`${mountTarget} .filter-alpha__btn`).forEach(btn => {
    const active = btn.dataset.letter === activeLetter
    btn.classList.toggle('filter-alpha__btn--active', active)
    btn.setAttribute('aria-pressed', active)
    const isAvailable = available.has(btn.dataset.letter)
    btn.classList.toggle('filter-alpha__btn--disabled', !isAvailable)
    btn.disabled = !isAvailable
  })

  document.getElementById('filter-toggle').textContent = activeFilterLabel()
}

function updateSlides() {
  document.querySelector(`${mountTarget} .swiper-wrapper`).innerHTML = renderSlides()
  initSwiper()
}

function bindFilterEvents() {
  document.querySelectorAll(`${mountTarget} .filter-bar__btn`).forEach(btn => {
    btn.addEventListener('click', () => {
      activeRegion = btn.dataset.region
      activeLetter = null
      updateFilterButtons()
      updateSlides()
    })
  })

  document.querySelectorAll(`${mountTarget} .filter-alpha__btn:not([disabled])`).forEach(btn => {
    btn.addEventListener('click', () => {
      activeLetter = activeLetter === btn.dataset.letter ? null : btn.dataset.letter
      updateFilterButtons()
      updateSlides()
    })
  })
}

function bindOverlayEvents() {
  const panel = document.getElementById('filter-panel')
  const toggle = document.getElementById('filter-toggle')
  const backdrop = panel.querySelector('.filter-panel__backdrop')
  const close = panel.querySelector('.filter-panel__close')

  toggle.addEventListener('click', () => panel.classList.add('filter-panel--open'))

  const closePanel = () => panel.classList.remove('filter-panel--open')
  backdrop.addEventListener('click', closePanel)
  close.addEventListener('click', closePanel)
}

export function init(target = '#app') {
  mountTarget = target
  extractFromDOM()

  const activeBtn = document.querySelector(`${mountTarget} .filter-bar__btn--active`)
  if (activeBtn) activeRegion = activeBtn.dataset.region

  initSwiper()
  bindFilterEvents()
  bindOverlayEvents()
}

export function destroy() {
  if (swiperInstance) {
    swiperInstance.destroy(true, true)
    swiperInstance = null
  }
  winzer = []
  regions = []
  activeRegion = 'Alle'
  activeLetter = null
}
